import styled from "styled-components";

export const RoundBorderedWrapper = styled.div`
  border: 1px solid #E3E3E3;
  border-radius: 20px;
  min-width: 70em;
  height: 76vh;
  padding: 16px;
`;
